import { Button, Card, type CardProps, Flex, Group, Indicator, Text, ThemeIcon, Title } from "@mantine/core";
import { IconCheck, IconEdit, IconFileTypePdf } from "@tabler/icons-react";
import type { MouseEvent } from "react";
import { convertToDateString } from "../../helpers/dates";
import type { Document } from "../../models/document";
import { Status } from "../../models/enums/status";
import styles from "./DocumentCard.module.css";

type DocumentCardProps = CardProps & {
  onOpen: () => void;
  onSign?: () => void;
  document: Document;
};

export function DocumentCard({ onOpen, onSign, document, ...props }: DocumentCardProps) {
  const _onSign = (event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => {
    onSign?.();
    event.stopPropagation();
  };
  return (
    <Indicator processing disabled={!document.new_flag} position="top-end" color="zli-orange" offset={10} tabIndex={0}>
      <Card w="100%" h="100%" className={styles.root} onClick={onOpen} {...props}>
        <Flex align="center" gap="md" direction={{ base: "column", sm: "row" }}>
          <ThemeIcon visibleFrom="md" color="zli-blue" size="xl" variant="subtle">
            <IconFileTypePdf size={40} />
          </ThemeIcon>
          <div>
            <Group>
              <Title ta="left" order={4}>
                {document.title}
              </Title>
              {!document.publish && document?.report?.status === Status.DISCUSSION && (
                <Title order={4} c="dimmed">
                  Entwurf
                </Title>
              )}
            </Group>

            <Text ta="left" c="dimmed">
              {document.published_at && convertToDateString(document.published_at)}
            </Text>
          </div>
          {onSign && !document.signed && (
            <Button
              className={styles.signed}
              variant="subtle"
              ml={{ md: "auto" }}
              color="zli-orange"
              onClick={(event) => _onSign(event)}
              rightSection={<IconEdit />}
            >
              Signieren
            </Button>
          )}
          {onSign && document.signed && (
            <Group ml={{ md: "auto" }} mr={{ md: "sm" }} gap="xs">
              <Text c="zli-green">Signiert</Text>
              <ThemeIcon color="zli-green" variant="subtle">
                <IconCheck />
              </ThemeIcon>
            </Group>
          )}
        </Flex>
      </Card>
    </Indicator>
  );
}
